/**
 * Determines whether PrintProductMountingOptionsAlertModal should fire based on the selected
 * PrintProductSize.
 *
 * @param {Object} options The options.
 * @param {Object} options.selectedPrintProductSize The selected PrintProductSize.
 * @param {Object} options.selectedPrintProductMount The selected PrintProductSizeMount.
 * @returns {boolean}
 */
export const shouldAlertPrintMountingOptions = ({
  selectedPrintProductSize,
  selectedPrintProductMount,
}) => {
  const printProductSizeMounts = selectedPrintProductSize?.mounts;
  const MIN_SIZE = 11 * 14;

  if (!printProductSizeMounts?.records?.length || selectedPrintProductMount) {
    return false;
  }

  const { width, height } = selectedPrintProductSize.print_size;
  return width * height >= MIN_SIZE;
};
